import dayjs from 'dayjs';
import { formatDate } from '@frontend/date';
import type { MockActivityData } from './use-mock-schedule-activity';

const locationId = '9a97d918-1b7e-42ce-b3b7-ecc9d8fd4eb3';
const today = dayjs();
const tomorrow = today.add(1, 'day').add(Math.floor(Math.random() * 24), 'hour');
const yesterday = today.subtract(1, 'day').add(Math.floor(Math.random() * 24), 'hour');
const todayISO = today.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
const tomorrowISO = tomorrow.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
const yesterdayISO = yesterday.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
const randomUUID = () => crypto.randomUUID();
const formatDateTime = (datetime: string) => formatDate(datetime, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]');

// TODO: Remove this mock once API is ready
export const data: MockActivityData[] = [
  {
    id: randomUUID(),
    locationId: locationId,
    bookingSubmissionId: randomUUID(),
    calendarEventId: randomUUID(),
    appointmentTime: null,
    appointmentId: '8da93f7d-4028-42e3-bcb0-cb6e18a6ec03',
    occurredAt: todayISO,
    activityType: 'REQUESTED',
    status: 'PENDING',
    patient: {
      patientId: '9a6adfd2-a1c3-5af7-8043-0d64a19ce3a2',
      firstName: 'Kinsley',
      lastName: 'Ferry',
    },
    service: {
      serviceId: randomUUID(),
      serviceName: 'Teeth Cleaning',
      serviceColor: '#466ad3',
      servicePattern: 'lined',
    },
    appointmentType: {
      appointmentTypeId: randomUUID(),
      appointmentTypeName: 'Teeth Whitening',
      appointmentTypeColor: '#FF5733',
      appointmentTypePattern: 'striped',
    },
    activitySourceType: 'STAFF_UI',
    actor: {
      actorType: 'AI',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: randomUUID(),
    locationId: locationId,
    bookingSubmissionId: randomUUID(),
    calendarEventId: randomUUID(),
    appointmentTime: formatDateTime('2026-04-01T09:30:00.000Z'),
    appointmentId: '8da93f7d-4028-42e3-bcb0-cb6e18a6ec03',
    occurredAt: yesterdayISO,
    activityType: 'RESCHEDULED',
    status: 'UNCONFIRMED',
    patient: {
      patientId: randomUUID(),
      firstName: 'Ricardo',
      lastName: 'Lowry',
    },
    appointmentType: {
      appointmentTypeId: randomUUID(),
      appointmentTypeName: 'Teeth Whitening',
    },
    activitySourceType: 'AI_VOICE',
    actor: {
      actorType: 'AI',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: randomUUID(),
    locationId: locationId,
    bookingSubmissionId: randomUUID(),
    calendarEventId: randomUUID(),
    appointmentTime: null,
    appointmentId: randomUUID(),
    occurredAt: yesterdayISO,
    activityType: 'CANCELED',
    status: 'UNKNOWN',
    patient: {
      patientId: randomUUID(),
      firstName: 'Kellan',
      lastName: 'Lednar',
    },
    appointmentType: {
      appointmentTypeId: randomUUID(),
      appointmentTypeName: 'Teeth Whitening',
    },
    activitySourceType: 'STAFF_UI',
    actor: {
      actorType: 'PATIENT',
      actorUserId: '',
      actorUserName: 'Therodore Thomas',
    },
  },
  //
  {
    id: randomUUID(),
    locationId: locationId,
    bookingSubmissionId: randomUUID(),
    calendarEventId: randomUUID(),
    appointmentTime: null,
    appointmentId: '8da93f7d-4028-42e3-bcb0-cb6e18a6ec03',
    occurredAt: yesterdayISO,
    activityType: 'REQUESTED',
    status: 'MESSAGED',
    patient: {
      patientId: '9a6adfd2-a1c3-5af7-8043-0d64a19ce3a2',
      firstName: 'Kinsley',
      lastName: 'Ferry',
    },
    appointmentType: {
      appointmentTypeId: '69910c33-9e84-58a2-9186-d591b3a022b9',
      appointmentTypeName: 'Teeth Whitening',
    },
    activitySourceType: 'STAFF_UI',
    actor: {
      actorType: 'AI',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: randomUUID(),
    locationId: locationId,
    bookingSubmissionId: randomUUID(),
    calendarEventId: randomUUID(),
    appointmentTime: null,
    appointmentId: '8da93f7d-4028-42e3-bcb0-cb6e18a6ec03',
    occurredAt: yesterdayISO,
    activityType: 'REQUESTED',
    status: 'MESSAGED',
    patient: {
      patientId: '9a6adfd2-a1c3-5af7-8043-0d64a19ce3a2',
      firstName: 'Kinsley',
      lastName: 'Ferry',
    },
    appointmentType: {
      appointmentTypeId: '69910c33-9e84-58a2-9186-d591b3a022b9',
      appointmentTypeName: 'Teeth Whitening',
    },
    activitySourceType: 'STAFF_UI',
    actor: {
      actorType: 'AI',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: randomUUID(),
    locationId: locationId,
    bookingSubmissionId: randomUUID(),
    calendarEventId: randomUUID(),
    appointmentTime: null,
    appointmentId: '8da93f7d-4028-42e3-bcb0-cb6e18a6ec03',
    occurredAt: yesterdayISO,
    activityType: 'REQUESTED',
    status: 'MESSAGED',
    patient: {
      patientId: '9a6adfd2-a1c3-5af7-8043-0d64a19ce3a2',
      firstName: 'Kinsley',
      lastName: 'Ferry',
    },
    appointmentType: {
      appointmentTypeId: '69910c33-9e84-58a2-9186-d591b3a022b9',
      appointmentTypeName: 'Teeth Whitening',
    },
    activitySourceType: 'STAFF_UI',
    actor: {
      actorType: 'AI',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: randomUUID(),
    locationId: locationId,
    bookingSubmissionId: randomUUID(),
    calendarEventId: randomUUID(),
    appointmentTime: null,
    appointmentId: '8da93f7d-4028-42e3-bcb0-cb6e18a6ec03',
    occurredAt: tomorrowISO,
    activityType: 'REQUESTED',
    status: 'MESSAGED',
    patient: {
      patientId: '9a6adfd2-a1c3-5af7-8043-0d64a19ce3a2',
      firstName: 'Kinsley',
      lastName: '',
    },
    appointmentType: {
      appointmentTypeId: '69910c33-9e84-58a2-9186-d591b3a022b9',
      appointmentTypeName: 'Teeth Whitening',
    },
    activitySourceType: 'STAFF_UI',
    actor: {
      actorType: 'AI',
      actorUserId: '',
      actorUserName: '',
    },
  },

  {
    id: '92462d03-d048-425b-8895-b53c168c6a06',
    locationId: '9a97d918-1b7e-42ce-b3b7-ecc9d8fd4eb3',
    bookingSubmissionId: '92462d03-d048-425b-8895-b53c168c6a06',
    calendarEventId: '',
    appointmentTime: null,
    appointmentId: '8da93f7d-4028-42e3-bcb0-cb6e18a6ec03',
    occurredAt: '2026-06-30T02:00:43.000Z',
    activityType: 'REQUESTED',
    status: 'APPROVED',
    patient: {
      patientId: '9a6adfd2-a1c3-5af7-8043-0d64a19ce3a2',
      firstName: 'mark',
      lastName: 'allen',
    },
    appointmentType: {
      appointmentTypeId: '69910c33-9e84-58a2-9186-d591b3a022b9',
      appointmentTypeName: 'fake update',
    },
    activitySourceType: 'OTHER',
    actor: {
      actorType: 'PATIENT',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: 'c9daaed8-9cf2-4bec-8ed5-c65e785b71e0',
    locationId: '9a97d918-1b7e-42ce-b3b7-ecc9d8fd4eb3',
    bookingSubmissionId: 'c9daaed8-9cf2-4bec-8ed5-c65e785b71e0',
    calendarEventId: '',
    appointmentTime: null,
    appointmentId: '8da93f7d-4028-42e3-bcb0-cb6e18a6ec03',
    occurredAt: '2026-06-25T06:13:43.847Z',
    activityType: 'CREATED',
    status: 'NO_SHOW',
    patient: {
      patientId: '21a02b4c-df6e-567a-a782-0c340509a3f9',
      firstName: 'Mayank',
      lastName: 'Agarwal',
    },
    appointmentType: {
      appointmentTypeId: '5f4ecd93-f844-5088-9150-ed3044ea8972',
      appointmentTypeName: 'WebSched New Patient Default',
    },
    activitySourceType: 'BOOKING_SITE',
    actor: {
      actorType: 'AI',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: 'ba8941d1-6fce-4a44-bfd9-03a07bd42584',
    locationId: '9a97d918-1b7e-42ce-b3b7-ecc9d8fd4eb3',
    bookingSubmissionId: 'ba8941d1-6fce-4a44-bfd9-03a07bd42584',
    calendarEventId: '',
    appointmentTime: null,
    appointmentId: '8da93f7d-4028-42e3-bcb0-cb6e18a6ec03',
    occurredAt: '2026-11-29T02:00:43.000Z',
    activityType: 'CREATED',
    status: 'NO_SHOW',
    patient: {
      patientId: '21a02b4c-df6e-567a-a782-0c340509a3f9',
      firstName: 'Mayank',
      lastName: 'Agarwal',
    },
    appointmentType: {
      appointmentTypeId: 'ee0cf4d8-dce8-519b-9959-4101f732e786',
      appointmentTypeName: 'Root Canal',
    },
    activitySourceType: 'WAITLIST',
    actor: {
      actorType: 'AI',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: '4e204fc7-2dda-4219-a637-acd0cf7e9fc3',
    locationId: '9a97d918-1b7e-42ce-b3b7-ecc9d8fd4eb3',
    bookingSubmissionId: '4e204fc7-2dda-4219-a637-acd0cf7e9fc3',
    calendarEventId: '',
    appointmentTime: null,
    appointmentId: '8da93f7d-4028-42e3-bcb0-cb6e18a6ec03',
    occurredAt: null,
    activityType: 'RESCHEDULED',
    status: 'COMPLETED',
    patient: {
      patientId: '862f5c34-a0ca-591a-87d3-56a5e6eff474',
      firstName: 'Allen',
      lastName: 'Allowed',
    },
    appointmentType: {
      appointmentTypeId: '49a817fd-63d6-5caf-9d08-10671d38b61a',
      appointmentTypeName: 'wasuuuuup-1',
    },
    activitySourceType: 'OTHER',
    actor: {
      actorType: 'SYSTEM',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: '92472b45-a654-4769-9615-c9e947ea0bfa',
    locationId: '9a97d918-1b7e-42ce-b3b7-ecc9d8fd4eb3',
    bookingSubmissionId: '92472b45-a654-4769-9615-c9e947ea0bfa',
    calendarEventId: '',
    appointmentTime: '2027-11-02T02:00:43.000Z',
    appointmentId: '8da93f7d-4028-42e3-bcb0-cb6e18a6ec03',
    occurredAt: '2027-11-29T02:00:43.000Z',
    activityType: 'CANCELED',
    status: 'COMPLETED',
    patient: {
      patientId: 'c521dad6-e80b-5ade-aefe-2a93b2df7d71',
      firstName: 'Phantom',
      lastName: 'Assassin',
    },
    appointmentType: {
      appointmentTypeId: '69910c33-9e84-58a2-9186-d591b3a022b9',
      appointmentTypeName: 'fake update',
    },
    activitySourceType: 'OTHER',
    actor: {
      actorType: 'SYSTEM',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: 'e6e0879d-1862-4449-84a2-c29cfe1d9d8b',
    locationId: '9a97d918-1b7e-42ce-b3b7-ecc9d8fd4eb3',
    bookingSubmissionId: 'e6e0879d-1862-4449-84a2-c29cfe1d9d8b',
    calendarEventId: '',
    appointmentTime: null,
    appointmentId: 'd4f32d42-cdbf-41c8-85f2-937efb044f22',
    occurredAt: null,
    activityType: 'CREATED',
    status: 'NO_SHOW',
    patient: {
      patientId: 'd63f4e3b-fec7-5f5b-b08f-789db6c2d9c1',
      firstName: 'Austin',
      lastName: 'Clark',
    },
    appointmentType: {
      appointmentTypeId: '2a9dd799-70a9-5202-82f7-526420545d85',
      appointmentTypeName: 'supsup-3',
    },
    activitySourceType: 'OTHER',
    actor: {
      actorType: 'SYSTEM',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: '3da72f5c-a082-4f5d-892f-f4f2fb91ca69',
    locationId: '9a97d918-1b7e-42ce-b3b7-ecc9d8fd4eb3',
    bookingSubmissionId: '3da72f5c-a082-4f5d-892f-f4f2fb91ca69',
    calendarEventId: '',
    appointmentTime: null,
    appointmentId: 'd4f32d42-cdbf-41c8-85f2-937efb044f22',
    occurredAt: null,
    activityType: 'REQUESTED',
    status: 'COMPLETED',
    patient: {
      patientId: '01e5a7cd-8839-5542-ae63-6470ac7402f2',
      firstName: 'Ankita',
      lastName: 'Kumar 4',
    },
    appointmentType: {
      appointmentTypeId: 'bb38d4f9-6dde-5b23-9b08-733a577fe5c6',
      appointmentTypeName: 'Prophy16',
    },
    activitySourceType: 'AI_VOICE',
    actor: {
      actorType: 'STAFF',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: 'ffc56280-af49-469e-978f-4e466dca319c',
    locationId: '9a97d918-1b7e-42ce-b3b7-ecc9d8fd4eb3',
    bookingSubmissionId: 'ffc56280-af49-469e-978f-4e466dca319c',
    calendarEventId: '',
    appointmentTime: null,
    appointmentId: 'd4f32d42-cdbf-41c8-85f2-937efb044f22',
    occurredAt: null,
    activityType: 'CANCELED',
    status: 'UNCONFIRMED',
    patient: {
      patientId: '01e5a7cd-8839-5542-ae63-6470ac7402f2',
      firstName: 'Ankita',
      lastName: 'Kumar 4',
    },
    appointmentType: {
      appointmentTypeId: '69910c33-9e84-58a2-9186-d591b3a022b9',
      appointmentTypeName: 'fake update',
    },
    activitySourceType: 'WAITLIST',
    actor: {
      actorType: 'SYSTEM',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: '8abddfd5-4900-4e6e-a501-1262b3bd3059',
    locationId: '9a97d918-1b7e-42ce-b3b7-ecc9d8fd4eb3',
    bookingSubmissionId: '8abddfd5-4900-4e6e-a501-1262b3bd3059',
    calendarEventId: '',
    appointmentTime: null,
    appointmentId: 'd4f32d42-cdbf-41c8-85f2-937efb044f22',
    occurredAt: null,
    activityType: 'CANCELED',
    status: 'COMPLETED',
    patient: {
      patientId: '97d0ee7b-9d1f-58fb-a342-b259513e5ba4',
      firstName: 'Anna',
      lastName: 'Allowed',
    },
    appointmentType: {
      appointmentTypeId: '3539f3f4-f190-589d-b220-b73db419cbf9',
      appointmentTypeName: 'test type',
    },
    activitySourceType: 'PMS',
    actor: {
      actorType: 'AI',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: '47f893a7-3328-4bb9-99a2-4f7ab465ffa9',
    locationId: '9a97d918-1b7e-42ce-b3b7-ecc9d8fd4eb3',
    bookingSubmissionId: '47f893a7-3328-4bb9-99a2-4f7ab465ffa9',
    calendarEventId: '',
    appointmentTime: null,
    appointmentId: 'd4f32d42-cdbf-41c8-85f2-937efb044f22',
    occurredAt: null,
    activityType: 'CREATED',
    status: 'COMPLETED',
    patient: {
      patientId: '7e2c3e5a-5044-5f35-b885-d0b19139229f',
      firstName: 'John',
      lastName: 'Allen',
    },
    appointmentType: {
      appointmentTypeId: '5f4ecd93-f844-5088-9150-ed3044ea8972',
      appointmentTypeName: 'WebSched New Patient Default',
    },
    activitySourceType: 'WAITLIST',
    actor: {
      actorType: 'STAFF',
      actorUserId: '',
      actorUserName: '',
    },
  },
  {
    id: '03336712-ea67-4fcc-8af8-e3135ff3d3f5',
    locationId: '9a97d918-1b7e-42ce-b3b7-ecc9d8fd4eb3',
    bookingSubmissionId: '03336712-ea67-4fcc-8af8-e3135ff3d3f5',
    calendarEventId: '',
    appointmentTime: null,
    appointmentId: 'd4f32d42-cdbf-41c8-85f2-937efb044f22',
    occurredAt: null,
    activityType: 'CREATED',
    status: 'REJECTED',
    patient: {
      patientId: 'd63f4e3b-fec7-5f5b-b08f-789db6c2d9c1',
      firstName: 'Austin',
      lastName: 'Clark',
    },
    appointmentType: {
      appointmentTypeId: 'e59b8535-7064-562b-8381-4c4407111a02',
      appointmentTypeName: 'Testinfra',
    },
    activitySourceType: 'OTHER',
    actor: {
      actorType: 'STAFF',
      actorUserId: '',
      actorUserName: '',
    },
  },
];
